__turbopack_context__.v({
  "NotifyMe": "NotifyMe-module__-PUmYq__NotifyMe",
  "button": "NotifyMe-module__-PUmYq__button",
  "form": "NotifyMe-module__-PUmYq__form",
  "formGroup": "NotifyMe-module__-PUmYq__formGroup",
  "icon": "NotifyMe-module__-PUmYq__icon",
  "input": "NotifyMe-module__-PUmYq__input",
  "label": "NotifyMe-module__-PUmYq__label",
  "notify": "NotifyMe-module__-PUmYq__notify",
  "section": "NotifyMe-module__-PUmYq__section",
  "top": "NotifyMe-module__-PUmYq__top",
});
